import { KeyInitiative } from 'partner360/entities/keyInitiatives'

export const getAlreadyCopiedSourceIds = (
  currentYearInitiatives: ReadonlyArray<Pick<KeyInitiative, 'PreviousEntryId'>>,
  recentlyCopiedSourceIds: ReadonlySet<number>
): Set<number> =>
  new Set([
    ...recentlyCopiedSourceIds,
    ...currentYearInitiatives
      .map((initiative) => initiative.PreviousEntryId)
      .filter((entryId): entryId is number => typeof entryId === 'number'),
  ])

export const getCopyablePreviousYearInitiatives = <T extends { EntryId: number }>(
  previousYearInitiatives: T[],
  alreadyCopiedSourceIds: ReadonlySet<number>
): T[] =>
  previousYearInitiatives.filter((initiative) => !alreadyCopiedSourceIds.has(initiative.EntryId))
